import React from 'react';
import PropTypes from 'prop-types';
import cx from '@/utils/cx';
import useStyle from './style';

const RadioIcon = ({
  checked,
  _color,
}) => {
  const classes = useStyle({ _color });

  return (
    <span className={cx(classes.radioIcon, checked && 'checked')} />
  );
};

RadioIcon.propTypes = {
  checked: PropTypes.bool,
  _color: PropTypes.string,
};

RadioIcon.defaultProps = {
  checked: '',
  _color: 'primary',
};

export default RadioIcon;
